import { AnnouncementLookupResolveService } from './shared/services/announcement-lookup-resolve.service';
import { AnnouncementListComponent } from '../announcements/announcement-list/announcement-list.component';
import { RouteApplicationStartupResolveService } from '../core/route-application-startup-resolve.service';
import { AnnouncementShellComponent } from '../announcements/announcement-shell/announcement-shell.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FutureAnnouncementsComponent } from './future-announcements/future-announcements.component';
import { ModerationAnnouncementComponent } from './moderation-announcement/moderation-announcement.component';
import { AuthGuard } from '../core/auth.guard';

const routes: Routes = [
  {
    path: 'announcements',
    component: AnnouncementShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: AnnouncementLookupResolveService,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'list',
      },
      {
        path: 'list',
        component: AnnouncementListComponent,
      },
      {
        path: 'future-announcements',
        component: FutureAnnouncementsComponent,
      },
      {
        path: 'moderation/:announcementId',
        component: ModerationAnnouncementComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AnnouncementsRoutingModule {}
